import { equalsCI, includesCI } from '../ui/listFilterHelpers';

export const DEFAULT_DESIGN_LIST_FILTERS = {
  search: '',
  sampleNo: '',
  concept: '',
  category: '',
  beamType: '',
};

export function getDesignBeamTypeOptions() {
  return [
    { value: '', label: 'All beam types' },
    { value: 'single', label: 'Single beam' },
    { value: 'multi', label: 'Multi beam' },
  ];
}

function matchesDesignCategory(item, categoryFilter) {
  if (!String(categoryFilter || '').trim()) return true;
  return (
    equalsCI(item.categoryName, categoryFilter) ||
    equalsCI(item.subCategoryName, categoryFilter)
  );
}

function matchesBeamType(item, beamType) {
  if (!beamType) return true;
  if (beamType === 'single') return item.singleBeam === true;
  if (beamType === 'multi') return item.singleBeam !== true;
  return true;
}

function matchesDesignSearch(item, query) {
  const key = String(query || '').trim().toLowerCase();
  if (!key) return true;
  return (
    String(item.conceptName || '').toLowerCase().includes(key) ||
    String(item.categoryName || '').toLowerCase().includes(key) ||
    String(item.subCategoryName || '').toLowerCase().includes(key) ||
    String(item.addPicks ?? '').includes(key) ||
    String(item.averagePicks ?? '').includes(key) ||
    String(item.totalCards ?? '').includes(key) ||
    String(item.readCount ?? '').includes(key) ||
    String(item.beamName || '').toLowerCase().includes(key)
  );
}

export function applyDesignListFilters(items, filters) {
  const f = { ...DEFAULT_DESIGN_LIST_FILTERS, ...filters };
  return (items || []).filter((item) => {
    if (!equalsCI(item.conceptName, f.concept)) return false;
    if (!matchesDesignCategory(item, f.category)) return false;
    if (!includesCI(item.sampleNo, f.sampleNo)) return false;
    if (!matchesBeamType(item, f.beamType)) return false;
    if (!matchesDesignSearch(item, f.search)) return false;
    return true;
  });
}

export function countActiveDesignFilters(filters) {
  const f = { ...DEFAULT_DESIGN_LIST_FILTERS, ...filters };
  let n = 0;
  if (String(f.search || '').trim()) n += 1;
  if (String(f.sampleNo || '').trim()) n += 1;
  if (String(f.concept || '').trim()) n += 1;
  if (String(f.category || '').trim()) n += 1;
  if (f.beamType && f.beamType !== '') n += 1;
  return n;
}

export function collectDesignConcepts(items) {
  const out = [];
  for (const item of items || []) {
    if (item.conceptName) out.push(item.conceptName);
  }
  return out;
}

export function collectDesignCategories(items) {
  const out = [];
  for (const item of items || []) {
    if (item.categoryName) out.push(item.categoryName);
    if (item.subCategoryName) out.push(item.subCategoryName);
  }
  return out;
}
